import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import { Drawer, CssBaseline, AppBar, Toolbar, List, Divider, IconButton, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    borderBottom: '1px solid #E6EDF5',
    boxShadow: 'none',
    // width: window.screen.width,
    width: '100%',
    left: 0,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(${window.screen.width}px - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    flexGrow: 0
  },
  hide: {
    display: 'none',
  },
  drawer: {
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
  },
  content: {
    flexGrow: 1,
    paddingTop: 56,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    minWidth: 300
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  itemList: {
    marginBottom: 'auto'
  },
  toolbar: {
    background: 'white',
  },
  toolbarText: {
    textAlign: 'center',
    flexGrow: 3,
    fontSize: 12,
    color: 'black',
    fontWeight: 'bold'
  },
  iconButton: {
    color: '#0A54A2',
    padding: 3,
  },
  sideBarName: {
    fontSize: 24,
    fontWeight: 'bold',
    margin: '15px 20px 5px'
  },
  companyName: {
    fontSize: 16,
    color: '#878787',
    fontWeight: 'bold',
    margin: '5px 20px'
  },
  customButtonContainer: {
    width: 48,
    display: 'none'
  },
  menuButtonContainer: {
    width: 48,
  },
  logOutSection: {
    position: 'absolute',
    width: '100%',
    bottom: 0,
  }
});

class MobileLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  handleDrawerOpen = () => {
    this.setState({ open: true });
  }

  handleDrawerClose = () => {
    this.setState({ open: false });
  }

  render() {
    const { classes, children, username } = this.props
    const { open } = this.state
    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open,
          })}
        >
          <Toolbar className={classes.toolbar}>
            <div id={'menuButtonToolbar'} className={classes.menuButtonContainer} >
              <IconButton
                color="primary"
                aria-label="open drawer"
                onClick={this.handleDrawerOpen}
                edge="end"
                className={clsx(classes.menuButton, open && classes.hide)}
              >
                <MenuIcon />
              </IconButton>
            </div>
            <div id={'customButtomContainer'} className={clsx(classes.customButtonContainer, open && classes.hide)} />
            <span id="nameBar" className={classes.toolbarText}>

            </span>

            <div className={classes.menuButtonContainer} ></div>
          </Toolbar>
        </AppBar>
        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
          id={'drawerMain'}
        >
          <div className={classes.drawerHeader}>
            <IconButton id={'closeButton'} onClick={this.handleDrawerClose}>
              <CloseIcon />
            </IconButton>
          </div>
          <span id="nameDrawer" className={classes.sideBarName}>{username}</span>
          {/* <span className={classes.companyName}>Company Name</span> */}
          <div id={'drawerMenu'}>
          </div>
          <Divider />
          <List className={classes.logOutSection}>
            <ListItem button>
              <ListItemIcon><FontAwesomeIcon icon={['fal', 'sign-out']} /></ListItemIcon>
              <ListItemText primary={'Log out'} />
            </ListItem>
          </List>
        </Drawer>
        <main id={'appContainer'}
          className={clsx(classes.content, {
            [classes.contentShift]: open,
          })}
        >
          {children}
        </main>
      </div>
    )
  }
}

export default withStyles(styles)(MobileLayout);